const currencyCode = (value) =>
  typeof value === 'string' && /^[a-z]{3}$/i.test(value)
    ? value.toUpperCase()
    : null;

export const getStoredCurrencyConfig = (code, symbol) => {
  const currency = currencyCode(code);
  if (!currency) return null;
  try {
    const currencySymbol =
      symbol ||
      new Intl.NumberFormat('en', {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol'
      })
        .formatToParts(0)
        .find((part) => part.type === 'currency')?.value;
    return { currencyCode: currency, currencySymbol };
  } catch {
    return null;
  }
};

export const formatStoredPaymentAmount = (amount, code, locale = 'en') => {
  const currency = currencyCode(code);
  if (
    amount == null ||
    amount === '' ||
    !Number.isFinite(Number(amount)) ||
    !currency
  )
    return null;
  try {
    return `${new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(amount))} ${currency}`;
  } catch {
    return null;
  }
};

export { currencyCode as normalizePaymentCurrency };
